import React, { Component, Fragment, useEffect, useState, lazy, Suspense } from "react";
import { Collapse, List, IconButton, ListItem, ListItemIcon, ListItemText, Icon, Drawer, Divider, Hidden } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import config from '../../../config/config.json';
import clsx from 'clsx';
import { ChevronLeft, ChevronRight } from '@material-ui/icons/';
import { enabledPermissions } from '../../../services/enabledPermissions';
import { connect } from "react-redux";

// const ConfiguracionModal = lazy(() => import("../../views/admin/sections/partials/ConfiguracionModal"));

const Sidebar = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const [enabledSidebarItems, setEnabledSidebarItems] = useState([]);
    // const [enabledDashboardItems, setEnabledDashboardItems] = useState([]);
    // const [openConfigModal, setOpenConfigModal] = useState(false)
    // const [sidebarLoaded, setSidebarLoaded] = useState(false);

    const handleDrawerCollapse = () => {
        setCollapsed(!collapsed);
    };

    // const handleCloseModalConfiguracion = () => setOpenConfigModal(false);

    const handleDrawerClose = () => {
        props.handleDrawerClose && props.handleDrawerClose();
    }

    useEffect(() => {
        if (window.localStorage.getItem('userData') != undefined) {
            let permissionsItems = JSON.parse(window.localStorage.getItem('userData')).modules;
            setEnabledSidebarItems(enabledPermissions(props.sidebar, permissionsItems))
            // setEnabledDashboardItems(enabledPermissions(props.dashboard, permissionsItems))
            // setSidebarLoaded(true);  // Establece la barra lateral como cargada
        }
    }, [props.userData]);

    const SidebarItem = (props) => {
        const [collapsed, setCollapsed] = React.useState(true);
        const { listItemText: { primary }, submenu, routing, icon, iconStyle, onClick: onClickProp } = props.item;

        function toggleCollapse() {
            setCollapsed(prevValue => !prevValue);
        }

        function onClick(e) {
            if (Array.isArray(submenu)) {
                toggleCollapse();
            }
            if (onClickProp) {
                onClickProp(e, props.item);
            }
        }

        let expandIcon;

        if (Array.isArray(submenu) && submenu.length) {
            expandIcon = !collapsed ? (
                <ExpandLessIcon />
            ) : (
                <ExpandMoreIcon />
            );
        }

        return (
            <Fragment>
                {routing !== "" ?
                    (<ListItem button component="a" href={`/${routing}`}>
                        <ListItemIcon><Icon style={iconStyle}>{icon}</Icon></ListItemIcon>
                        <ListItemText primary={primary} className={props.collapsed ? 'collapsedItem' : ''} />
                        {expandIcon}
                    </ListItem>)
                    :
                    (<ListItem button onClick={onClick}{...props}>
                        <ListItemIcon><Icon style={iconStyle}>{icon}</Icon></ListItemIcon>
                        <ListItemText primary={primary} className={props.collapsed ? 'collapsedItem' : ''} />
                        {expandIcon}
                    </ListItem>)
                }

                <Collapse in={!collapsed} timeout="auto" unmountOnExit className={'nested'} >
                    {Array.isArray(submenu) ? (
                        <List component="div" disablePadding>
                            {submenu.map((subItem, index) => (
                                <SidebarItem
                                    key={index}
                                    item={subItem}
                                />
                            ))}
                        </List>
                    ) : null}
                </Collapse>
            </Fragment>
        );
    }

    const getSidebarList = (isMobile = false) => {

        // function openModal() {
        //     setOpenConfigModal(true)
        // }

        return <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className="sidebarnav-list"
            style={{ marginTop: isMobile ? 0 : 64 }}
        >
            {enabledSidebarItems.map((sidebarItem, index) => (
                <SidebarItem
                    key={index}
                    item={sidebarItem}
                />
            ))}

            {/* <ListItem button onClick={openModal}>
                <ListItemIcon><Icon>settings</Icon></ListItemIcon>
                <ListItemText primary="Configuración" className='collapsedItem'  />
            </ListItem> */}
        </List>
    }

    return (
        <>
            <Hidden xsDown>
                <Drawer variant="permanent" classes={{ paper: clsx('drawerPaper', !collapsed && 'drawerPaperClose') }} open={collapsed}>
                    {getSidebarList()}

                    <IconButton className="toolbarDrawerButton" onClick={handleDrawerCollapse}>
                        {!collapsed ? <ChevronRight /> : <ChevronLeft />}
                    </IconButton>
                </Drawer>
            </Hidden>

            <Hidden smUp>
                <Drawer
                    variant='temporary'
                    classes={{ paper: 'drawerPaper' }}
                    open={props.openDrawerMobile}
                    onClose={handleDrawerClose}
                >
                    <div className='sidebarnav-back'>
                        <IconButton onClick={handleDrawerClose}>
                            {props.openDrawerMobile ? <ChevronLeft /> : <ChevronRight />}
                        </IconButton>
                    </div>
                    <Divider />

                    {getSidebarList(true)}
                </Drawer>
            </Hidden>

            {/* <Suspense fallback={<div>Loading...</div>}>
                {sidebarLoaded && (
                    <ConfiguracionModal
                        openModalConfiguracion={openConfigModal}
                        handleCloseModalConfiguracion={handleCloseModalConfiguracion}
                        itemsDashboard={enabledDashboardItems}
                    />
                )}
            </Suspense> */}
        </>
    );
}

class SidebarNavigation extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Sidebar
                userData={this.props.responseUserLogin}
                sidebar={config.sidebar}
                // dashboard={config.cards}
                openDrawerMobile={this.props.openDrawerMobile}
                handleDrawerClose={this.props.handleDrawerClose}
            />
        )
    }
}

const mapStateToProps = reducers => {
    return reducers.loginReducer;
};

export default connect(mapStateToProps)(SidebarNavigation);